import { pmWhite } from "./Constants";

const PageFormData = {
    buttonTextColor: '#5D1247',
    buttonBackgroundColor: pmWhite,
    buttonTitle: 'ACESSAR CONTEÚDO',
    buttonWidth: '100%',
    theme: 'dark',
}

export default PageFormData;